import { render, staticRenderFns } from "./modifypassword.vue?vue&type=template&id=d40cbff8&scoped=true&"
import script from "./modifypassword.vue?vue&type=script&lang=ts&"
export * from "./modifypassword.vue?vue&type=script&lang=ts&"
import style0 from "./modifypassword.vue?vue&type=style&index=0&id=d40cbff8&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40cbff8",
  null
  
)

export default component.exports